import { TransactionsTable } from './transactions-table/TransactionsTable'

export function InvestorTransactionsTab() {
  return (
    <div className="grow md:pt-5">
      <TransactionsTable />
    </div>
  )
}
